export enum TopicFeedViews {
  browse = "browse",
  latest = "latest",
}

export const TOPIC_FEED_SELECTED_VIEW = "TopicFeedSelectedView";
